<template>
  <el-form label-position="top">
    <el-form-item>
      <el-radio v-for="record of tableData" v-model="form.service" :key="record.code" :label="record.code">{{ record.name }}&nbsp;<span class="badge badge-primary badge-pill">{{ record.total }} </span></el-radio>
    </el-form-item>
    <el-form-item :label="$t('utilizar-valor')">
      <el-radio v-model="form.type" key="1" label="1">Correios</el-radio>
      <el-radio v-model="form.type" key="2" label="2">Spred (%)</el-radio>
      <el-input-number v-model="form.spred" size="mini" v-if="form.type === '2'" :precision="2" :step="0.1" :controls="false"></el-input-number>
    </el-form-item>
  </el-form>
</template>
<script>
import AuditPendenciesOptions from './AuditPendenciesOptions';

export default {
  name: "AuditPendenciesValueMoreForm",
  props: ["tableData"],
  components: {
    AuditPendenciesOptions ,
  },
  data() {
    return {
      form: {
        service: '',
        type: '1',
        spred: 0,
      }
    }
  },  
  methods: {
    get() {
      const vm = this;
      return vm.form;
    },
  },
};
</script>
<style scoped>
.list-group-item {
  padding-top: 15px !important;
}
</style>